import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { submitCart, cart, currentOrder, updateItemQuantity, submitCCStatus, submitStatus, getCurrentOrder } from '../reducers/cart';
import { getUser, getSubsite, reloadUser } from '../reducers/auth';
import { useNavigate } from "react-router-dom";
import AddressModal from "./modals/AddressModal";
import ShippingService from "../services/shipping.service";
import OrderService from "../services/order.service";
import PaymentService from "../services/payment.service";
import { Container, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import UserService from "../services/user.service";
import AnimateHeight from 'react-animate-height';
import ChooseAddress from "./ChooseAddress";

const Checkout = () => {
  let navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const cartItems = useSelector(cart);
  const currOrder = useSelector(currentOrder);
  const submitted = useSelector(submitStatus);
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const [addressModalShow, setAddressModalShow] = useState(false);
  const [paymentType, setPaymentType] = useState("balance");
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [billingStreet, setBillingStreet] = useState('');
  const [billingStreet2, setBillingStreet2] = useState('');
  const [billingCity, setBillingCity] = useState('');
  const [billingState, setBillingState] = useState('');
  const [billingZip, setBillingZip] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [token, setToken] = useState('');
  const ccStatus = useSelector(submitCCStatus);
  const currentSubsite = useSelector(getSubsite);
  const [shipping, setShipping] = useState();
  const [isExpanded, setIsExpanded] = useState(false);
  const [height, setHeight] = useState(0);
  const [newAddress, setNewAddress] = useState(null);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
    setHeight(isExpanded ? 0 : 'auto');
  };

  let content = "";
  let total = 0.0;
  let totalCount = 0;
  let weight = 0.0;
  let shippingCost = null;

  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: {
      firstname: user.firstname,
      lastname: user.lastname,
      street1: user.billing_street,
      street2: user.billing_street2,
      city: user.billing_city,
      state: user.billing_state,
      zip: user.billing_zip
    },
  });

  const finishSubmit = async (token) => {
    console.log(token);
    setToken(token);
    processCC(token);
  }
  /*console.log("USER BALANCE", user.subsiteBalance.balance);
  /*useEffect(() => {
    if(ccStatus === "succeeded")
        navigate("/confirm");
  
  }, [ccStatus, navigate]);
  */

  const processCC = async (token) => {
    setIsSubmitting(true);

    console.log("SPLIT TRANSACTION", paymentType);
    //setAlertMessage("The form was submitted. Check the console to see the output data.");
    console.log("TOKEN::", token.token);
    var ccTotal = 0;
    var balanceTotal = 0;
    var balance = 0;
    if (user.subsiteBalance) {
      balance = user.subsiteBalance.balance;
    }
    if (total < balance) {
      await submitBalance();
    } else {
      // cc transaction
      console.log("SHIPPING", shippingCost);
      ccTotal = total + shippingCost.shippingAmount.amount - balance;
      balanceTotal = total + shippingCost.shippingAmount.amount - ccTotal;

      console.log("CCTOTAL" + ccTotal, balanceTotal);
      console.log("TOTAL IN finishSubmit", total);
      console.log("CC ORDER", currOrder.id);

      try {
        const result = await PaymentService.submitCCPayment({ token: token.token, amount: ccTotal, shipping: shippingCost.shippingAmount.amount, orderId: currOrder.id, balanceUsed: balanceTotal, paymentType: "creditcard" });
        console.log("CC PROCESS RESULT", result);
        if (result.message) {
          setAlertMessage(result.obj.responsetext);
        } else {
          navigate("/confirm", { state: { orderId: result.id } });
        }
      } catch (e) {
        console.log("ERROR", e);
        setAlertMessage(e.response.data.obj.responsetext);
      }

      setIsSubmitting(false);
    }

    setIsSubmitting(false);

  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
	      if(!newAddress && !currOrder.deliveryAddress) {
      setAlertMessage("Please select a shipping address or add a new one.");
      setIsSubmitting(false);
      return;
    }

    console.log("ON SUBMIT CALLED");
    //await UserService.updateBillingAddress(data);
    /*user.billing_firstname = data.firstname;
    user.billing_lastname = data.lastname;
    user.billing_street = data.street1;
    user.billing_street2 = data.street2;
    user.billing_city = data.city;
    user.billing_state = data.state;
    user.billing_zip = data.zip;
*/
    if (paymentType === "split" || paymentType === "cc") {
      window.CollectJS.startPaymentRequest();
      //processCC();
      console.log("End payment request");
    } else {
      await submitBalance();
    }
  }

  const submitBalance = async () => {
    var result = await OrderService.submitOrder(currOrder.id, paymentType);
    if (result.error) {
      setAlertMessage(result.message);
    } else {
      navigate("/confirm", { state: { orderId: currOrder.id } });
    }
  }

  useEffect(() => {
    if (submitted === "succeeded")
      navigate("/confirm", { state: { orderId: currOrder.id } });
    else {
      // show error message

    }

  }, [submitted, navigate]);

  useEffect(() => {
    //getShipping();
    // reload user to get new balance
    dispatch(reloadUser());

    window.CollectJS.configure({
      variant: 'inline',
      styleSniffer: true,
      callback: (token) => {
        console.log(token);
        finishSubmit(token);
      },
      invalidCss: {
        "background-color": "#FF9999"
      },
      validCss: {
        color: '#175033',
        "background-color": "#DDFFDD"
      },
      customCss: {
        'border-color': '#FFFFFF',
        'border-style': 'solid'
      },
      focusCss: {
        'border-color': '#37805B00',
        'border-style': 'solid',
        'border-width': '3px'
      },
      fields: {
        ccnumber: {
          placeholder: 'CC Number',
          selector: '#ccnumber'
        },
        ccexp: {
          placeholder: 'CC Expiration',
          selector: '#ccexp'
        },
        cvv: {
          placeholder: 'CVV',
          selector: '#cvv'
        }
      }
    });

  }, []);


  useEffect(() => {
    total = 0.0;
    totalCount = 0.0;

    for (var i = 0; i < cartItems.length; i++) {
      total += cartItems[i].price * cartItems[i].quantity;
      totalCount += cartItems[i].quantity;
    }
    var balance = 0;
    if (user.subsiteBalance) {
      balance = user.subsiteBalance.balance;
    }
    if (total > balance) {
      setPaymentType("split");
      getShipping("split");
    } else {
      setPaymentType("balance");
      //getShipping("balance");
    }

  }, [cartItems, user]);
  useEffect(() => {
    total = 0.0;
    totalCount = 0.0;
    var balance = 0;
    if (user.subsiteBalance) {
      balance = user.subsiteBalance.balance;
    }

    for (var i = 0; i < cartItems.length; i++) {
      total += cartItems[i].price * cartItems[i].quantity;
      totalCount += cartItems[i].quantity;
    }
    if (total > balance) {
      setPaymentType("split");
      getShipping("split");
    } else {
      setPaymentType("balance");
      //getShipping("balance");
    }

  }, []);
  //  useEffect(() => {
  //    });
  //}, [currOrder]);

  cartItems.map(item => {
    total += item.price * item.quantity;
    totalCount += item.quantity;
  });

  const typeChanged = (event) => {
    setPaymentType(event.target.id);
  }

  const closeAddressModal = async (update, newAddress) => {
    //setAddressModalShow(false);
    toggleExpansion();
    if(update) {
      await OrderService.updateBillingAddress(newAddress.id);
      dispatch(reloadUser());
      dispatch(getCurrentOrder());
    }
  }

  const showAddressModal = () => {
    setAddressModalShow(true);
  }

  const getShipping = async (type) => {
    if (!type) type = paymentType;
    weight = 0.0;
    cartItems.map(item => {
      weight += item.product.weight * item.quantity;
    });
    var balance = 0;
    if (user.subsiteBalance) {
      balance = user.subsiteBalance.balance;
    }

    var shippingData = await ShippingService.getShipping({ weight: weight, orderId: currOrder.id, paymentType: type, balance: balance });
    setShipping(shippingData.data);
    shippingCost = shippingData.data;
  }


  const qtyChanged = (item, event) => {
    let args = { item: item, quantity: parseInt(event.target.value) };
    dispatch(updateItemQuantity(args));
  }

  return (
    <div className="container" style={{ paddingBottom: 100 }}>
      <Form onSubmit={handleSubmit(onSubmit)}>

        {cartItems.length === 0 && (
          <div class="alert">Your cart is empty. Please add items to your cart before checking out.</div>
        )}
        {cartItems.length > 0 && (
          <div>
            <Container>
            <Row style={{marginTop: 10}}>
                <Col xs={12} >
                <AnimateHeight duration={500} height={height == 0 ? 'auto' : 0}>
                    {currOrder.deliveryName && (
                      <div>
                        <h2>Delivering to {currOrder.deliveryName}</h2>
                        <p style={{ marginLeft: 30, padding: 5, border: "1px solid #CCCCCC" }}>{currOrder.deliveryAddress}<br />
                                        {currOrder.deliveryAddress2 != null && currOrder.deliveryAddress2 != "" && <>{currOrder.deliveryAddress2}<br /></>}
                                        {currOrder.deliveryCity}, {currOrder.deliveryState} {currOrder.deliveryZip}<br />
                                        </p>

                    </div>)}
                    <div><Button onClick={toggleExpansion}>Change Address</Button></div>
                    <div style={{ padding: "15px" }}>
                      <input type="checkbox" {...register("addressValidation", { required: true })} /> <span style={{ fontWeight: "500", fontSize: "larger" }}>I confirm this address is the correct shipping address.</span>
                      {errors.addressValidation?.type === 'required' && <div className="error" >Please Confirm your Address</div>}
                  </div>
                  </AnimateHeight>
                  <AnimateHeight duration={500} height={height}>
                    <ChooseAddress close={closeAddressModal} setAddress={setNewAddress} />
                  </AnimateHeight>

                </Col>
              </Row>
              <Row>
                <Col>
                  <h2>Total</h2>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div class="total" style={{ marginLeft: 30, border: "1px solid #cccccc", width: "30%" }}>Subtotal: <strong>{(total).toLocaleString(undefined, {
                    style: "currency",
                    currency: "USD",
                  })}</strong><br /></div>
                  {shipping && shipping.shippingAmount && (
                    <div class="total" style={{ marginLeft: 30, border: "1px solid #cccccc", width: "30%" }}>Shipping: <strong>{(shipping?.shippingAmount?.amount).toLocaleString(undefined, {
                      style: "currency",
                      currency: "USD",
                    })}</strong><br /></div>
                  )}
                  {user.subsiteBalance?.balance > 0 && (
                    <>
                      <div class="total" style={{ marginLeft: 30, border: "1px solid #cccccc", width: "30%" }}>Balance: <strong>-{(user.subsiteBalance?.balance).toLocaleString(undefined, {
                        style: "currency",
                        currency: "USD",
                      })}</strong><br /></div>
                      <div class="total" style={{ marginLeft: 30, border: "1px solid #cccccc", width: "30%" }}><strong>Total: {((total + shipping?.shippingAmount?.amount - user.subsiteBalance?.balance) > 0 ?
                        (total + shipping?.shippingAmount?.amount - user.subsiteBalance?.balance) : 0).toLocaleString(undefined, {
                          style: "currency",
                          currency: "USD",
                        })}</strong><br /></div>
                    </>
                  )}
                  {(!user.subsiteBalance || user.subsiteBalance?.balance == 0) && (
                    <div class="total" style={{ marginLeft: 30, border: "1px solid #cccccc", width: "30%" }}><strong>Total: {((total + shipping?.shippingAmount?.amount) > 0 ?
                      (total + shipping?.shippingAmount?.amount) : 0).toLocaleString(undefined, {
                        style: "currency",
                        currency: "USD",
                      })}</strong><br /></div>
                  )}

                </Col>
              </Row>
              <Row>
                <Col>
                  <h2>Payment</h2>
                </Col>
              </Row>
              <Row>

                <Col xs={12} style={{ marginLeft: 40 }}>
                  {currentSubsite.paymentOptions.includes("balance") && (
                    <div class="content">
                      {!user.subsiteBalance &&
                        <>
                          <div class="alert">Your total is more than your available balance.
                            Your balance will be used up and the remaining balance will charged to your credit card.<br />
                            Balance - ${user.subsiteBalance ? user.subsiteBalance?.balance : "0.00"}<br />
                            Credit Card - ${(total + shipping?.shippingAmount?.amount).toFixed(2)}

                          </div>
                        </>
                      }
                      {(total > user.subsiteBalance?.balance) &&
                        <>
                          <div class="alert">Your total is more than your available balance.
                            Your balance will be used up and the remaining balance will charged to your credit card.<br />
                            Balance - ${user.subsiteBalance ? user.subsiteBalance?.balance : "0.00"}<br />
                            Credit Card - ${(total + shipping?.shippingAmount?.amount - user.subsiteBalance?.balance).toFixed(2)}

                          </div>
                        </>
                      }
                      <div style={{ padding: "15px" }}>
                        <input type="checkbox" {...register("terms", { required: true })} /><span style={{ fontWeight: "500", fontSize: "larger" }}> I understand that any remaining balance that is not used in this transaction will be forfeited
                        after submitting this order.</span>
                        {errors.terms?.type === 'required' && <div className="error" >Please Accept the Terms</div>}
                      </div>

                    </div>
                  )}

                </Col>
              </Row>
              {alertMessage && (
                <Row><Col>
                  <div className="alert">
                    {alertMessage}
                  </div>
                </Col></Row>
              )}

              <Row>
                <Col xs={12} style={{ marginLeft: 40 }}>
                  {currentSubsite.paymentOptions.includes("creditcard") && paymentType == "creditcard" || paymentType == "split" && (
                    <div class="payment-container">
                      <h3>Credit Card Details</h3>
                      <div class="content">
                        <Form.Group className="mb-3" controlId="street1">
                          <Form.Label>First Name</Form.Label>
                          <input className="checkoutFormInput"
                            {...register("firstname", { required: true })} /><br />
                          {errors.firstname && <div className="error" >First Name is required</div>}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="lastname">
                          <Form.Label>Last Name</Form.Label>
                          <input className="checkoutFormInput"
                            {...register("lastname", { required: true })} /><br />
                          {errors.lastname && <div className="error" >Last Name is required</div>}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="street1">
                          <Form.Label>Billing Street</Form.Label>
                          <input className="checkoutFormInput"
                            {...register("street1", { required: true })} /><br />
                          {errors.street1 && <div className="error" >Street is required</div>}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="street2">
                          <Form.Label>Billing Apt/Suite</Form.Label>
                          <input className="checkoutFormInput"
                            {...register("street2")} /><br />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="city">
                          <Form.Label>Billing City</Form.Label>
                          <input className="checkoutFormInput"
                            {...register("city", { required: true })} /><br />
                          {errors.city && <div className="error" >City is required</div>}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="state">
                          <Form.Label>Billing State</Form.Label>
                          <select className="checkoutFormInput"
                            name="state"
                            {...register("state", { required: true })}
                          >
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                          </select>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="zip">
                          <Form.Label>Billing Zip Code</Form.Label>
                          <input className="checkoutFormInput"
                            {...register("zip", {
                              required: "Zip code is required",
                              pattern: {
                                value: /^\d{5}(?:[-\s]\d{4})?$/,
                                message: "Invalid zip code format"
                              }
                            })} /><br />
                          {errors.zip?.type === 'required' && <div className="error" >Zip Code is required</div>}
                          {errors.zip?.type === 'pattern' && <div className="error" >{errors.zip.message}</div>}

                        </Form.Group>
                        <div>
                          <hr />
                        </div>
                        <Form.Group className="mb-3" controlId="ccn">
                          <Form.Label>Credit Card Number</Form.Label>
                          <div id="ccnumber" style={{
                            padding: "5px",
                            width: "40%",
                            borderRadius: "5px",
                            border: "1px solid #333"
                          }} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="cce">
                          <Form.Label>Credit Card Expiration (mm/yy)</Form.Label>
                          <div id="ccexp" style={{
                            padding: "5px",
                            width: "40%",
                            borderRadius: "5px",
                            border: "1px solid #333"
                          }} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="ccv">
                          <Form.Label>CVV</Form.Label>
                          <div id="cvv" style={{
                            padding: "5px",
                            width: "40%",
                            borderRadius: "5px",
                            border: "1px solid #333"
                          }} />
                        </Form.Group>

                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  {alertMessage && (
                    <Row><Col>
                      <div className="alert">
                        {alertMessage}
                      </div>
                    </Col></Row>
                  )}
                  {currentSubsite.paymentOptions.includes("creditcard") && paymentType == "creditcard" || paymentType == "split" && (
                    <div style={{ padding: "15px" }}>
                      <input type="checkbox" {...register("review", { required: true })} /><span style={{ fontWeight: "500", fontSize: "larger" }}> I have reviewed Shipping Address, Billing Address and Credit Card information and it is correct.</span>
                      {errors.review?.type === 'required' && <div className="error" >Please review your order before submitting</div>}
                    </div>
                  )}
                  <Button style={{ width: "100%", fontWeight: "bold" }} variant="warning"
                    onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>Place Order</Button>
                </Col>
              </Row>
            </Container>
            <div></div>

          </div>
        )}
        {addressModalShow && <AddressModal show={addressModalShow} closeAddressModal={closeAddressModal} />}
      </Form>
    </div>
  );
};
export default Checkout;
